import { render, staticRenderFns } from "./AppMenuFooter.vue?vue&type=template&id=2cad81a0&scoped=true&"
import script from "./AppMenuFooter.vue?vue&type=script&lang=js&"
export * from "./AppMenuFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuFooter.vue?vue&type=style&index=0&id=2cad81a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad81a0",
  null
  
)

export default component.exports